module.exports = "/dist//ionicons.woff?2c159d0d05473040b53ec79df8797d32";